import { render, staticRenderFns } from "./course-year-change-log.vue?vue&type=template&id=7bd795d2&scoped=true&"
import script from "./course-year-change-log.js?vue&type=script&lang=js&"
export * from "./course-year-change-log.js?vue&type=script&lang=js&"
import style0 from "./course-year-change-log.vue?vue&type=style&index=0&id=7bd795d2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bd795d2",
  null
  
)

export default component.exports